module.exports = __webpack_public_path__ + "static/media/icon_4.3aa80c63.svg";